import { render, staticRenderFns } from "./OrderManageShipping.vue?vue&type=template&id=54c8bebc"
import script from "./OrderManageShipping.vue?vue&type=script&lang=js"
export * from "./OrderManageShipping.vue?vue&type=script&lang=js"
import style0 from "./OrderManageShipping.vue?vue&type=style&index=0&id=54c8bebc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports